import { useCallback } from 'react';
import multiItemAccessoryServices from '../../../services/MultiItemAccessories/multiItemAccessoryService';
import { ActionSchema,  } from './types';
import { actionTypes } from './MultiAccessoryProvider';
/**
 * Custom hook that provides action creators for Multi Accessory Context
 * @param dispatch - Dispatch function from the MultiAccessoryContext
 * @returns Object containing all action creator functions
 */
export const useMultiAccessoryActions = (dispatch: React.Dispatch<ActionSchema>) => {

  // Action: Set Recommended Accessories
  const setRecommendedAccessories = useCallback((payload: any) => {
    dispatch({ type: actionTypes.recommendedAccessories, payload });
  }, [dispatch]);
  // Action: Set Multi Item Accessories List
  const setMultiItemAccessoriessList = useCallback((payload: any) => {
    // Ensure this function is only called in response to user actions or effects, not during render
    dispatch({ type: actionTypes.multiItemAccessoriessList, payload });
  }, [dispatch]);
  // Action: Set Device Session Values
  const setDeviceSessionValues = useCallback((payload: any) => {
    dispatch({ type: actionTypes.deviceSessionValues, payload });
  }, [dispatch]);
  // Action: Set Selected Payment Type
  const setSelectedPaymentType = useCallback((payload: string) => {
    dispatch({ type: actionTypes.selectedPaymentType, payload });
  }, [dispatch]);
  
  // Action: Set Selected Tab
  const setSelectedTab = useCallback((payload: string) => {
    dispatch({ type: actionTypes.selectedTab, payload });
  }, [dispatch]);

  // Action: Set Previous Tab
  const setPreviousTab = useCallback((payload: string) => {
    dispatch({ type: actionTypes.previousTab, payload });
  }, [dispatch]);

  // Action: Set Show Mini Cart
  const setShowMiniCart = useCallback((payload: boolean) => {
    dispatch({ type: actionTypes.showMiniCart, payload });
  }, [dispatch]);

  /**
   * Async Action: Get Recommended Accessories
   * @param cartId - The cart ID to fetch recommended accessories for
   */
  const getRecommendedAccessory = useCallback(async ({cartId, recommendationsType}: any) => {
    try {
      // Dispatch START action to set loading state
      dispatch({ type: actionTypes.recommendedAccessoriesStart, payload: null });
      const response: any = await multiItemAccessoryServices.getRecommendedAccessoryData(cartId,recommendationsType);

      // Dispatch SUCCESS action with the response data
      dispatch({
        type: actionTypes.RecommendedAccessoriesSuccess,
        payload: { [recommendationsType]: response , tabkey: recommendationsType}
      });

      return response;
    } catch (error) {
      // Dispatch FAILURE action on error
      dispatch({ type: actionTypes.recommendedAccessoriesFailure, payload: null });
    }
  }, [dispatch]);

  // Return all action creators
  return {
    setRecommendedAccessories,
    setMultiItemAccessoriessList,
    setDeviceSessionValues,
    setSelectedPaymentType,
    setSelectedTab,
    setPreviousTab,
    setShowMiniCart,
    getRecommendedAccessory,
  };
};
